export const upload = {
  name: "upload" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M1.6 2.5a.9.9 0 0 1 .9-.9h19a.9.9 0 0 1 .9.9V13a.9.9 0 0 1-1.8 0V3.4H3.4V13a.9.9 0 0 1-1.8 0V2.5Zm9.764 4.864a.9.9 0 0 1 1.272 0l5 5a.9.9 0 1 1-1.272 1.272L12.9 10.173V21.5a.9.9 0 0 1-1.8 0V10.173l-3.464 3.463a.9.9 0 0 1-1.272-1.272l5-5Z" clip-rule="evenodd"/></svg>`,
  keywords: ["upload"],
  category: "action" as const,
};
